import axios from 'axios';

const hostString = 'https://127.0.0.1:16566/';

export async function checkJoinCertificateServer() {
  const result = await axios.post(`${hostString}?op=setup`, {});

  return result.data;
}

export async function openSelectCertificate() {
  const result = await axios.post(`${hostString}?op=certSelect`, {
    certImageUrl: `${window?.origin}/images/incomeTaxRefund/banner_bznav_refund_infotech.png`,
    nxKeypad: ''
  });

  return {
    signCertFile: result.data?.file1,
    signPriFile: result.data?.file2,
    certPassword: result.data?.cert_pw
  };
}

export async function getCertificateInfo(signCertFile: string, signPriFile: string, certPassword: string) {
  const result = await axios.post(`${hostString}?op=execute`, {
    orgCd: 'common',
    svcCd: 'getCertInfo',
    appCd: 'bznav',
    signCert: signCertFile,
    signPri: signPriFile,
    signPw: certPassword
  });

  if (result.data?.errYn !== 'N') {
    throw new Error(result.data?.errMsg);
  }

  return {
    der2Pem: result.data?.DER2PEM,
    key2Pem: result.data?.KEY2PEM,
    certInfo: result.data?.CERT_INFO,
    dn: result.data?.DN
  };
}
